import { ProductState, ProductType } from '@/core/typings/enums';

export default function formatProduct(p: ProductResponse): ProductResponse {
  if (p.archived) {
    p.productState = ProductState.Archive;
  } else {
    if (p.product_type === 'private_space') {
      p.productState = ProductState.PrivateSpaces;
    } else if (!p.published && !p.visible) {
      p.productState = ProductState.Draft;
    } else if (p.published && p.visible) {
      p.productState = ProductState.Published;
    } else if (p.published && !p.visible) {
      p.productState = ProductState.Hidden;
    }
  }
  switch (p.product_type) {
    case 'private_space':
      p.productType = ProductType.PrivateSpace;
      break;
    case 'media_library':
      p.productType = ProductType.Membership;
      break;
    case 'course':
      p.productType = ProductType.Course;
      break;
    case 'bundle':
      p.productType = ProductType.Course;
      break;
    case 'private_coaching':
      p.productType = ProductType.PrivateCoaching;
      break;
    case 'event_only':
      p.productType = ProductType.InPersonOnly;
      break;
    case 'punch_card':
      p.productType = ProductType.PrepaidClassCard;
      break;
  }
  return p;
}
